import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import { useAuth0 } from "../../../providers";
import ForbiddenPage from "./ForbiddenPage";

export const PrivateRoute = ({
  organization,
  superUser,
  userFetched,
  component: Component,
  path,
  ...rest
}) => {
  const { loading, isAuthenticated, loginWithRedirect } = useAuth0();

  useEffect(() => {
    if (loading || isAuthenticated) {
      return;
    }

    const fn = async () => {
      await loginWithRedirect({
        appState: { targetUrl: window.location.pathname },
      });
    };

    fn();
  }, [loading, isAuthenticated, loginWithRedirect, path]);

  // There used to be a logout here whenever the organization in redux differed
  // from user_metadata.organization in the token. That is now a NORMAL state: the
  // token carries the user's default organization while redux carries whichever
  // one they have selected, and with a selector the two disagree by design. The
  // check would have logged people out on every switch.
  //
  // Nothing replaces it. Being allowed to act as an organization is decided by
  // the backend against the memberships in the token, not by comparing two
  // client-side values, and a selection the user is not entitled to is refused
  // there. reconcileActiveOrg (AppRouter) keeps the stored choice valid.

  const render = (props) =>
    isAuthenticated && organization ? <Component {...props} /> : null;

  // Render forbidden page if not authorized
  return isAuthenticated && (organization) ? (
    <Route path={path} render={render} {...rest} />
  ) : !loading && isAuthenticated ? (
    userFetched && <ForbiddenPage />
  ) : null;
};
